import request from "@/utils/request";

export default function agentBindRFIDCard(params) {
  return request({
    url: `/user/agent/RFIDCardController/bindRFIDCard`,
    method: "post",
    data: params,
  });
}
